// extracted by mini-css-extract-plugin
export default {"table":"ErpBookingsTable_table__nNsDe","justLabel":"ErpBookingsTable_justLabel__GqGPD","customCell":"ErpBookingsTable_customCell__2F40B","amount":"ErpBookingsTable_amount__3OUyU"};